var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStatisticsOutline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.1001 19C2.1001 18.5029 2.50304 18.1 3.0001 18.1H21.0001C21.4972 18.1 21.9001 18.5029 21.9001 19C21.9001 19.497 21.4972 19.9 21.0001 19.9H3.0001C2.50304 19.9 2.1001 19.497 2.1001 19Z",
    fill: "#023F80"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.5001 5.89998C16.003 5.89998 15.6001 5.49703 15.6001 4.99998C15.6001 4.50292 16.003 4.09998 16.5001 4.09998H21.0001C21.4972 4.09998 21.9001 4.50292 21.9001 4.99998V9.49998C21.9001 9.99703 21.4972 10.4 21.0001 10.4C20.503 10.4 20.1001 9.99703 20.1001 9.49998V7.17277L14.1365 13.1364C13.785 13.4878 13.2152 13.4878 12.8637 13.1364L9.5001 9.77277L3.63649 15.6364C3.28502 15.9878 2.71517 15.9878 2.3637 15.6364C2.01223 15.2849 2.01223 14.7151 2.3637 14.3636L8.8637 7.86358C9.21517 7.51211 9.78502 7.51211 10.1365 7.86358L13.5001 11.2272L18.8273 5.89998H16.5001Z",
    fill: "#023F80"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStatisticsOutline);
export default __webpack_public_path__ + "static/media/statistics_outline.90f7c5cb5333383f800dc162efce4aa5.svg";
export { ForwardRef as ReactComponent };